import { hooks, mui, React } from '_core';

import { DraftParams } from './types';
import PipelineSignalsSelector from '../../common/forms/pipelined-signals-selector';

type FormProps = {
  params: DraftParams;
  setParams: (_p: DraftParams) => void;
};

const Form = ({ params, setParams }: FormProps) => {
  const uiStyles = hooks.useUiStyles();
  const [signals, setSignals] = React.useState(params.analysis_pipelined_signals || [{} as any]);

  React.useEffect(() => {
    setParams({
      ...params,
      analysis_pipelined_signals: signals,
    });
  }, [signals]);

  return (
    <mui.core.Box sx={uiStyles.widgetEditMode}>
      <mui.core.Box my={2}>
        <PipelineSignalsSelector signals={signals} setSignals={setSignals} hide_labels />
      </mui.core.Box>
    </mui.core.Box>
  );
};

export default Form;
